export enum UsersSlug {
    Qualifications = 'qualifications',
    Activities = 'activities',
    Score = 'score',
    Skills = 'skills'
}
